import React, { Component } from 'react'
import { connect } from 'react-redux'
import { NoContentBox } from 'components/basic'

class Soon extends Component {
  render () {
    return (
      <div className='content-wrapper flexbox-absolute-center'>
        <NoContentBox icon='clock-o' text='This feature will be available soon' />
      </div>
    )
  }
}
//eslint-disable-next-line
Soon = connect(state => state.siteReducer)(Soon)
export default Soon



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/2.3/core/soon.js